<light-layout>
  <div class="__page-root">
    <hero name="Virginia State Police" kicker="Firearms Application.">
      <div class="cover-image hero-background tinted"></div>
      <back-to-button></back-to-button>
    </hero>
    <div class="sections">
      <app-summary color="#FF2828"
                   content="The administration of the Commonwealth of Virginia’s statewide Firearms Application Program is the responsibility of Virginia State Police.">
        <role [style.width.%]="100">
          <li>Java based Spring framework</li>
          <li>Spring security</li>
          <li>Struts Framework</li>
          <li>HTML 5</li>
          <li>JSP Tag libraries</li>
          <li>Cascaded style sheets (CSS)</li>
          <li>JQuery (JavaScript framework)</li>
          <li>Oracle 12g</li>
          <li>Lead Software Development</li>
          <li>Quality Test and Support</li>
        </role>
      </app-summary>

      <challenge color="#FF2828"
                     content="The Firearms application is used by firearm dealers in Virginia to conduct background checks on potential
                      gun buyers. Integrated with major federal systems, the Firearms application is used by more than 2200
                      dealers serving 4,000 plus requests per day. The application is of such a scale that fifteen business users
                      are continuously monitoring and approving background check requests if intervention is required. This is
                      a critical application that must always run on schedule.
                      Each background check has very strict SLA of 3 days. The Virginia State Police needed a performance
                      measurement tool for business users to better understand how to drive efficiencies during periods
                      where high volumes of requests are received, impacting service. To better allocate their users, the State
                      Police needed a tool for predictive analysis that could provide on-demand reports to better understand
                      users’ efficiency."></challenge>

      <solution-header content="a re-engineered solution"></solution-header>

      <solution>
        <p>
          Data Concepts started working on designing and architecting the solution, which analyzes user data to
          better predict the efficiency of each user and help make business decisions on the basis of that analysis.
          The application was developed using Java-based Spring framework to control access, handle business
          logic, and integrate with the backend database to retrieve and analyze the data in order to generate
          reports.
          The extensive and detailed report enabled the client to make proactive decisions and utilize their user’s
          skills in more effective ways. This was the huge plus for our client, who gained control over their data
          and also bolstered accident or error prevention.
        </p>
        <ul class="pseudo">
          <li>- Deployable Java Spring Module with data analysis and reporting capability.</li>
          <li>- Integration with real time oracle database for analysis and on demand reporting.</li>
          <li>- Capability to integrate on demand reports with other applications.</li>
          <li>- Project source code and detailed documentation.</li>
        </ul>
      </solution>

      <outcome color="#FF2828"
                   content="The module developed by Data Concepts analyzes the user activity and provides an on-demand report.
                      This report helped our client utilize the business users’ hours in an efficient manner and deploy
                      additional resources when there was a high request volume.
                      Control over data empowers our client to make better and more proactive decisions, resulting in
                      efficiency and savings."></outcome>
    </div>
  </div>
</light-layout>
